import { COLOR_GREY_200 } from 'src/colors';

const styles = {
  card: {
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    border: `1px solid ${COLOR_GREY_200}`,
    height: '100%',
  },
};

export default styles;
